"use strict";

import variable from './variable';


(function ($) {
    var menuTimeout = undefined;
    var position = 0;
    var el = $(window);

// should start at 0

    $(document).ready(function () {
        if ($('html').hasClass('fp-enabled')) {
            el = '#normal-page';
        }
        init(el);
        //SWD-320 - Scroll to section Enquiry Form
        $('a[href="#contact"]').on('click', function () {
            try{
                jQuery.fn.fullpage.moveSectionDown();
            }
            catch (e) {
                $("section[name='contact']")[0].scrollIntoView({behavior: 'smooth'});
            }
        });
        //SWD-320 - Scroll down section
        $('.fa-continue.animation').on('click', function () {
            jQuery.fn.fullpage.moveSectionDown();
        });
    });

    $(window).resize(function () {
        init(el);
    });

    function init(el)
    {
        $(el).scroll(function () {
            if ($(document).width() > 1024) {
                var scroll = $(el).scrollTop();

                if (scroll > position) {
                    // console.log('scrollDown');
                    if ($('body').hasClass('menu-collapse')) {
                        $('#toggle-nav-main-open').click();
                    }
                } else {
                    // console.log('scrollUp');
                    clearTimeout(menuTimeout);
                    if (!$('body').hasClass('menu-collapse')) {
                        $('#toggle-nav-main-open').click();
                    }

                    menuTimeout = menuTrigger();
                }
                position = scroll;
            }
        });

    }

    function menuTrigger()
    {
        menuTimeout = setTimeout(()=>{
            if ($('body').hasClass('menu-collapse')) {
                $('#toggle-nav-main-open').click();
            }
        }, 3000);

        $('#nav-full-box').on('mouseenter', function () {
            clearTimeout(menuTimeout);
        });

        return menuTimeout;
    }
})(jQuery);